import React from "react";
import styles from "./AuthDrawerSheet.module.scss";

interface AuthDrawerSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const AuthDrawerSheet: React.FC<AuthDrawerSheetProps> = ({
  open,
  onClose,
  children,
}) => {
  return (
    <>
      <div
        className={`${styles.backdrop} ${open ? styles.backdropOpen : ""}`}
        onClick={onClose}
      />
      <aside
        className={`${styles.drawer} ${
          open ? styles.drawerOpen : styles.drawerClosed
        }`}
      >
        <button
          className={`${styles.closeBtn} ${open ? "" : styles.closed}`}
          onClick={onClose}
          aria-label="Close"
          type="button"
        >
          <svg
            width="31"
            height="31"
            viewBox="0 0 31 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.75 0.75L29.9147 29.9147"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M0.749358 29.9147L29.9141 0.75"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className={styles.content}>{children}</div>
      </aside>
    </>
  );
};

export default AuthDrawerSheet;
